import { YStack } from "tamagui";

import { useIsDarkTheme } from "@/theme/helpers";

export default function LandingGradientBackground({
  children,
  darkColor = "var(--curai800)",
  lightColor = "var(--curai100)",
  lightStartPct = "0%",
}: {
  children: React.ReactNode;
  darkColor?: string;
  lightColor?: string;
  lightStartPct?: string;
}) {
  const isDark = useIsDarkTheme();

  return (
    // @ts-ignore — web-only CSS gradient
    <YStack
      width="100%"
      style={{
        background: isDark
          ? `linear-gradient(to bottom, var(--background) 0%, ${darkColor} 100%)`
          : `linear-gradient(to bottom, var(--background) ${lightStartPct}, ${lightColor} 100%)`,
      }}
    >
      {children}
    </YStack>
  );
}
